import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import chakraTheme from './theme/theme';
import { initI18n } from './i18n/i18nCore';
import { detectInitialLanguage, persistLanguage } from './i18n/usePublicLocale';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './features/auth/AuthProvider';
import { queryClient } from './lib/queryClient';
import { initOtel } from './lib/otel';

// Start OpenTelemetry as early as possible (no-op until a collector is configured).
initOtel();

// Initialize i18n with the visitor's preferred language (stored → browser → English),
// persisting changes for anonymous (public marketing) visitors.
initI18n(detectInitialLanguage(), persistLanguage);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ChakraProvider theme={chakraTheme}>
      <BrowserRouter>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </AuthProvider>
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);

